import React, { Fragment, useEffect } from "react";
import Humberg from "../../../../elements/Humberg.jsx";
import UpdateProductForm from "./UpateProductForm.jsx";
import { useDispatch, useSelector } from "react-redux";
import { allCategoriesAction, allProductMarketsAction, allProductTypesAction, clearErrors, loadSettingsAction } from "../../../../redux/actions/userActions.js";
import { useSearchParams } from "react-router-dom";
import { singleProductAction } from "../../../../redux/actions/productActions.js";
import Loader from "../../../loader/loader.jsx";
import { toast } from "react-toastify";



export const currencyOptions = [
  { option: "USD", value: "USD" },
  { option: "EUR", value: "EUR" },
  { option: "GBP", value: "GBP" },
  { option: "JPY", value: "JPY" },
  { option: "INR", value: "INR" },
  { option: "Riyal", value: "SAR" },
  { option: "Dirham", value: "AED" },
  { option: "PKR", value: "PKR" },
];


const UpdateProduct = () => {


  const dispatch = useDispatch()


  const { categories } = useSelector(state => state.allCategories)
  const { productTypes } = useSelector(state => state.allProductTypes);
  const { settings } = useSelector(state => state.loadSettings)
  const { loading, error, product } = useSelector((state) => state.Products)
  const { productMarkets } = useSelector(state => state.allProductMarkets);




  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");



  useEffect(() => {



    const Headerlinkks = document.querySelectorAll(".headerLinks");
    const subLinks = document.querySelectorAll(".subLinks");
    const element = document.getElementById("products")
    const subElement = document.getElementById("add-product");


    Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
    subLinks.forEach(el => el.classList.remove("activeSubLink"));
    element?.classList.add("activeHeaderLink");
    subElement?.classList.add("activeSubLink");

    document.title = `Update Product Details`;

  }, []);
  // Remove one quantity



  useEffect(() => {
    dispatch(allCategoriesAction())
    dispatch(allProductTypesAction())
    dispatch(allProductMarketsAction())
    dispatch(loadSettingsAction())

  }, [dispatch])




  useEffect(() => {

    if (id) {
      dispatch(singleProductAction(id))
    }

  }, [id, dispatch])




  useEffect(() => {
    if (error) {
      toast.error(error)
      dispatch(clearErrors())
    }
  }, [error, dispatch])


  useEffect(() => {

    document.title = `Update Product `;


  }, [])


  return (
    <Fragment>
      {loading && <Loader />}
      <Humberg header="Products" headerLink="/" children={"Update Products"} />
      <section className="p-[1vmax_1.5vmax] relative">
        <UpdateProductForm categories={categories} productTypes={productTypes} settings={settings} currencyOptions={currencyOptions} product={product}   productMarkets={productMarkets} />
      </section>
    </Fragment>
  );
};

export default UpdateProduct;
